<template>
    <div>
    <div class="fm-container">
        <Backer />
        <div>
            <div v-if="!name" style="font-size: 25px; font-weight: bold; margin-bottom: 5px; width: 100%; text-align: center;">Generate Delivery List</div>

            <div v-else style="font-size: 25px; font-weight: bold; margin-bottom: 5px; width: 100%; text-align: center;">
                {{ name }}
            </div>
        </div>


        <div v-if="!name" style="text-align: center; padding: 3px;  margin-bottom: 5px;">
            <div style="display: inline-block; width: auto; background: #efefef; padding: 3px; border: 1px dashed black; font-size: 12px; color: black;">
                <b-card-text>
                    <span>DUE ON: </span>
                    <b-input id="pick_date" autocomplete="off" size="sm" variant="dark" :placeholder="startDate+' - '+ endDate" style="display: inline-block; width: 220px;"></b-input>
                    <b-button size="sm" variant="dark" style="display: inline-block;" @click="fetch_init">FETCH</b-button>
                </b-card-text>
            </div>
            <!-- <div style="display: inline-block; margin: 10px; width: auto; background: #efefef; padding: 3px; border: 1px dashed black; font-size: 12px; color: black;">
                <b-card-text>

                    <span>INVOICE #: </span>
                    <span>
                        <b-form @submit="search_invoice_id" style="display: inline-block;">
                            <b-form-input v-model="query.invoice_id" size="sm" style="display: inline-block; width: 220px;"></b-form-input>
                            <b-button type="submit" size="sm" variant="dark" style="display: inline-block;" >SEARCH</b-button>
                        </b-form>
                    </span>
                </b-card-text>
            </div> -->
        </div>

        <div style="margin-top: 10px; min-height: 200px; padding: 10px;">
            <b-overlay :show="data_being_loaded" rounded="sm">               
                <div v-if="data.length > 0" style="">
                    <div style="width: 80%; display: inline-block;">
                        <div style="text-align: left; margin: 10px;">
                            <!--b-button size="sm" variant="primary" @click="autoAssignFulfillLocations">Auto Assign Fulfill Locations</b-button-->
                            <b-button size="sm" variant="success" @click="saveDeliveryList">Save Delivery List</b-button>
                        </div>

                        <div v-for="invoice, idx in data" style=" padding: 10px; margin: 10px; background: beige; border: 1px solid darkgray;" class="invoice_div">
                            <div style="width: 100%; display: table;">
                                <div style="display: table-row; background: #6b7c81; color: white;">
                                    <div style="display: table-cell; text-align: left; padding: 3px;">
                                        <div style="display: inline; padding: 2px;">
                                            INVOICE # <b>{{invoice.invoice_id}}</b>
                                        </div>

                                        <!-- <span style="display: inline; padding: 2px; font-size: 12px; margin-left: 10px;">
                                            {{ invoice.customer.zipcode }}
                                        </span> -->

                                        <div style="display: inline; padding: 2px;">
                                            <b-badge size="sm" variant="secondary" style="cursor: pointer; background-color: tomato;" @click="removeInvoice(idx)">Remove Invoice</b-badge>
                                        </div>
                                    </div>

                                    <div style="display: table-cell; text-align: right; padding: 3px;">
                                        
                                        <div style="display: inline-block; padding: 3px; font-size: 12px;">
                                            <span>Delivery Zone:</span>
                                            <div style="display: inline-block; width: 150px;">
                                                <b-form-select
                                                    v-model="invoice.delivery_zone_id"
                                                    :options="delivery_zones"
                                                    value-field="value"
                                                    text-field="name"
                                                    size="sm"
                                                    
                                                >
                                                </b-form-select>
                                            </div>
                                        </div>

                                        <div style="display: inline-block; font-size: 12px; padding: 3px; font-weight: bold;">
                                            <span>Truck:</span>
                                            <div style="display: inline-block; width: 50px;">
                                                <b-form-input
                                                    v-model="invoice.truck_number"
                                                    size="sm"
                                                    v-on:keyup="calcTruckStats"
                                                    autocomplete="off"
                                                    :style="{'background-color': ((invoice.truck_number ? 'white' : 'yellow'))}"
                                                >
                                                </b-form-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <table style="width: 100%;">
                                <thead>
                                    <tr style="background: gainsboro; color: black;">
                                        <td class="ipt_tdhr">ITEM</td>
                                        <td class="ipt_tdhr">SKU</td>
                                        <td class="ipt_tdhr">SOLD FROM</td>
                                        <td class="ipt_tdhr">QUANTITY</td>
                                        <td class="ipt_tdhr">CUBES</td>
                                        <td class="ipt_tdhr">FULFILL FROM</td>
                                        <td class="ipt_tdhr">ACTIONS</td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item, itemidx in invoice.items">
                                        <td class="ipt_tdr">
                                            <span style="">{{item.product_name }}</span>

                                            <span v-show="item.is_special == true" style="padding: 1px; background: orange; color: white; border-radius: 3px; margin-left: 5px;">
                                            special
                                            </span>

                                            <!-- <div v-show="item.children.length > 0" style="margin-bottom: 10px;">
                                                <b-card-text>
                                                    
                                                    <div v-for="child, idxx in item.children" style="font-size: 10px !important; width: auto; background-color: #efefef; padding: 3px; margin: 6px;">
                                                        
                                                        <b>{{child.product_name}}</b> ({{ child.sku }}) X {{child.quantity}}

                                                    </div>
                                                </b-card-text>
                                            </div> -->

                                        </td>

                                        <td class="ipt_tdr">
                                            {{ item.product_sku }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ locationsdict[invoice.location_id] }} / {{ sublocationsdict[invoice.sublocation_id] }}
                                        </td>
        
                                        <td class="ipt_tdr">
                                            {{ item.quantity }}
                                        </td> 

                                        <td class="ipt_tdr">
                                            {{ item.cubes }}
                                        </td>                                
                                    
                                        <td class="ipt_tdr"><!-- {{ locationsdict[item.source_location_id] }} / {{ sublocationsdict[item.source_sublocation_id] }} -->
                                            <div style="margin: 3px; style=width: auto; display: inline-block;">
                                                <b-form-select
                                                    v-model="item.source_location_id"
                                                    :options="locations"
                                                    
                                                    size="sm"
                                                >
                                                </b-form-select>
                                            </div>
                                            <div style="margin: 3px; style=width: auto; display: inline-block;">
                                                <b-form-select
                                                    v-if="item.source_location_id != null"
                                                    v-model="item.source_sublocation_id"
                                                    :options="sublocations.filter(function(d){return d.location_id == item.source_location_id})"
                                                    
                                                    size="sm"
                                                >
                                                </b-form-select>
                                            </div>

                                        </td>

                                        <td class="ipt_tdr">
                                            <span style="display: inline-block; margin: 3px;">
                                                <b-badge style="cursor: pointer; font-size: 12px;" variant="secondary" size="sm" @click="removeInvoiceItem(idx, itemidx)">Remove</b-badge>

                                                <b-badge style="cursor: pointer; font-size: 12px;" variant="success" size="sm" @click="getItemAvailability(idx, itemidx)">Check</b-badge>
                                            </span>
                                        </td> 
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="sidenav" style="display: inline-block;">
                        <div style="margin: 10px;">
                            <div v-if="truck_stats.length > 0" style="border: 1px solid black; font-size: 13px;">
                                <b-table small striped hover :items="truck_stats"></b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </b-overlay>

            <b-modal id="modal-availability" scrollable title="" size="md" hide-footer>
                <Availability :viewdata="{availability_data:availability_data, product_id: q_product_id, product_sku: q_product_sku}" :locationsdict="locationsdict" :sublocationsdict="sublocationsdict" />
            </b-modal>
        </div>
    </div>
    <!--footer-->
        <!-- <div style="position: fixed; bottom: 0; left: 0; width: 100%; min-height: 100px; background: yellow; opacity: 0.3;">
            
        </div> -->
    </div>

</template>

<script>
    import $ from 'jquery'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Availability from '@/components/importables/Availability'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    import 'lightpick/css/lightpick.css'
    import moment from 'moment'

    export default {
        name: "DeliveryList",
        components: {Backer, Multiselect, VueGoodTable, Availability},
        props: [],
        data: function(){
            return {
                userDetails: {properties: {}},
                startDate: null,
                endDate: null,
                data_being_loaded: false,
                data: [],
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                delivery_zones: [],
                delivery_zones_dict: {},
                truck_stats: {},
                availability_data: [],
                q_product_id: null,
                q_product_sku: null,
                name: this.$route.params.name,
            }
        },
        methods: {
            fetch_open_orders_for_delivery: function(){
                let startDate = this.startDate;
                let endDate = this.endDate;
                if (moment(endDate) < moment().startOf('day')){
                    this.$bvToast.toast(
                        "Cannot generate for a past date.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                let path = "/api/sales/get_items_open_for_delivery/"
                let data = {start_date: this.startDate, end_date: this.endDate}
                let that = this;

                let s = function(response){
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.data = response.data.result;
                        that.truck_stats = [];
                        //that.data = Array.from({ length: 500 - 1 + 1 }, (_, i) => i)
                    }
                    that.data_being_loaded = false;
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "An error occurred. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.data_being_loaded = false;
                }

                this.data_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_delivery_list: function(){
                let name = this.name;

                let path = "/api/inventory/get_delivery_list/"
                let data = {name: name}
                let that = this;

                let s = function(response){
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.data = response.data.result;
                        that.calcTruckStats();
                        //that.data = Array.from({ length: 500 - 1 + 1 }, (_, i) => i)
                    }
                    that.data_being_loaded = false;
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "An error occurred. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.data_being_loaded = false;
                }

                this.data_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_init: function(e) {
                if (e){
                    e.preventDefault();
                }

                if (this.name){
                    this.fetch_delivery_list();
                }
                else{
                    this.fetch_open_orders_for_delivery();
                }
            },
            fetch_prereqs: function() {
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/get_delivery_zones/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getSyncP,
                        s: function(response){
                            if (response.data.result){
                                that.delivery_zones = response.data.result.map(function(d){
                                    return {value: d.id, name: d.name}
                                });
                                that.delivery_zones_dict = that.delivery_zones.reduce((map, obj) => (map[obj.value] = obj.name, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading delivery zones.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ];

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }                   
                }
            },
            calcTruckStats: function(e){   
                if (e){
                    e.preventDefault();
                }
                let invoices = this.data;
                let truck_stats = {};
                for (var i=0; i<invoices.length; i++){
                    let truck_number = invoices[i].truck_number;
                    let total_cubes = invoices[i].items.map(function(d){return (d.cubes || 0) }).reduce((a, b) => a + b, 0);

                    if (truck_number != null || truck_number != undefined){
                        if (truck_number in truck_stats){
                            truck_stats[truck_number] += total_cubes
                        }
                        else {
                            truck_stats[truck_number] = total_cubes
                        }
                    }
                }
                this.truck_stats = Object.keys(truck_stats).map(function(d){ return  {"Truck": d, "Cubes": truck_stats[d]}  });
                console.log(this.truck_stats)
                
            },
            removeInvoice: function(idx){
                let ack = confirm("Removing this will keep all items in this invoice open for delivery. Are you sure?");
                if (!ack){
                    return
                }
                this.data.splice(idx, 1);
            },
            removeInvoiceItem: function(idx, itemidx){
                let ack = confirm("Removing this will keep this product of invoice open for delivery. Are you sure?");
                if (!ack){
                    return
                }
                this.data[idx].items.splice(itemidx, 1);
            },

            saveDeliveryList: function(e){
                if (e) {
                    e.preventDefault();
                }

                let ack = confirm("Are you sure to proceed?");
                if (!ack){
                    return
                }

                let delivery_list_items = [];
                for (var i=0; i<this.data.length; i++){
                    let truck_number = this.data[i].truck_number;
                    let invoice_id = this.data[i].invoice_id;
                    let delivery_zone_id = this.data[i].delivery_zone_id;

                    if (!truck_number){
                        this.$bvToast.toast(
                            "All deliveries must have proper trucks assigned.", 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        return
                    }

                    for (var j=0; j<this.data[i].items.length; j++){
                        let product_id = this.data[i].items[j].product_id;
                        let product_sku = this.data[i].items[j].product_sku;
                        let quantity = this.data[i].items[j].quantity;
                        let itemid = this.data[i].items[j].itemid;

                        let source_location_id = this.data[i].items[j].source_location_id;
                        let source_sublocation_id = this.data[i].items[j].source_sublocation_id;

                        if (!source_location_id || !source_sublocation_id){
                            this.$bvToast.toast(
                                "All deliveries must have fulfilling locations / sublocations assigned.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                            return
                        }

                        let delivery_item = {
                            product_id: product_id,
                            product_sku: product_sku,
                            quantity: quantity,
                            source_location_id: source_location_id,
                            source_sublocation_id: source_sublocation_id,
                            invoice_id: invoice_id,
                            itemid: itemid,
                            truck_number: truck_number,
                            delivery_zone_id: delivery_zone_id,
                        }
                        delivery_list_items.push(delivery_item);
                    }
                }

                let that = this;
                let path = "/api/inventory/save_delivery_list/"
                let data = {
                    data: delivery_list_items, 
                    name: "DLIST_"+(moment().format("MM-DD-YYYY_HH_mm"))
                }

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.data_being_loaded = false;
                    }
                    else {
                        that.$bvToast.toast(
                            "Delivery list saved.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.data_being_loaded = false;

                        let name = response.data.result.name;
                        if (name){
                            // that.$router.go();
                            that.$router.push({path: "/tools/delivery_lists/"});
                        }
                    }
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Failed to save delivery list. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.data_being_loaded = false;
                }

                this.data_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);

            },

            autoAssignFulfillLocations: function(e) {
                if (e){
                    e.preventDefault();
                }

                let that = this;
                let path = "/api/inventory/resolve_invoice_items_sources_batch/"
                let candidates = [];

                for (var i=0; i<this.data.length; i++){
                    let invoice_id = this.data[i].invoice_id;
                    for (var j=0; j<this.data[i].items.length; j++){
                        let item = this.data[i].items[j];
                        let candidate = {
                            invoice_id: invoice_id,
                            itemid: item.itemid,
                            product_id: item.product_id, 
                            product_sku: item.product_sku, 
                            quantity: item.quantity, 
                            source_location_id: item.source_location_id, 
                            source_sublocation_id: item.source_sublocation_id
                         
                        }
                        candidates.push(candidate);
                    }
                }
                let data = {candidates: candidates} 
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.fetch_init();
                    that.data_being_loaded = false;
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error assigning..", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.fetch_init();
                    that.data_being_loaded = false;
                }

                this.data_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);

            },
            getItemAvailability: function(idx, itemidx){
                let path = "/api/inventory/get_tr_item_availability/";
                let item = this.data[idx].items[itemidx];
                let data = {product_id: item.product_id, product_sku: item.product_sku};
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.availability_data = response.data.result;
                        that.q_product_id = item.product_id;
                        that.q_product_sku = item.product_sku;
                        that.$bvModal.show("modal-availability");
                    }
                    
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "An error occurred trying to fetch product availability. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                Requestor.getAsync(path, data, s, f);
            }

        },
        created: function() {
            let userDetails = localStorage.userDetails;
            if (userDetails) {
                this.userDetails = JSON.parse(userDetails);
                console.log(this.$route.params)
                //this.name = this.$route.params.name;
            }
        },
        mounted: function() {
            if (!this.name){
                const Lightpick = require("lightpick");
                let that = this;
                this.startDate = moment().format("MM-DD-YYYY");
                this.endDate = moment().add(7, 'day').format("MM-DD-YYYY");
                var picker = new Lightpick({
                    field: document.getElementById("pick_date"),
                    singleDate: false,
                    repick: true,
                    startDate: that.startDate,
                    endDate: that.endDate,
                    onSelect: function(start, end) {
                        // var str = '';
                        // str += start ? start.format('Do MMMM YYYY') + ' to ' : '';
                        // str += end ? end.format('Do MMMM YYYY') : '...';
                        // document.getElementById('result-2').innerHTML = str;
                        console.log(start, end);
                        that.startDate = start ? start.format("MM-DD-YYYY") : "";
                        that.endDate = end ? end.format("MM-DD-YYYY") : "";
                    }
                });
            }
            this.fetch_prereqs();
            this.fetch_init();
        }
    }
</script>

<style scoped>
    .sidenav {
        width: 130px;
        position: fixed;
        z-index: 1;
        top: 30%;
        right: 100;
        overflow-x: hidden;
        display: inline-block;
    }

    .ipt_tdr {
        padding: 2px;
        text-align: center;
        border: 1px solid black;
        font-size: 12px;
        background: whitesmoke;
        font-weight: bold;
    }

    .ipt_tdhr {
        padding: 2px;
        text-align: center;
        font-size: 12px;
        font-weight: normal;
        border: 1px solid black;
    }

    @media print  
    {
       div .invoice_div {
           page-break-inside: avoid;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/DeliveryList.vue